import React, { useEffect, useRef } from "react";

const TweetEmbed = ({ tweetId }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        // Load Twitter embed script if not already present
        if (!window.twttr) {
            const script = document.createElement("script");
            script.src = "https://platform.twitter.com/widgets.js";
            script.async = true;
            document.body.appendChild(script);
        } else {
            window.twttr.widgets.load(containerRef.current);
        }
    }, [tweetId]);

    return (
        <div ref={containerRef}>
            <blockquote className="twitter-tweet" data-theme="dark">
                <a href={`https://twitter.com/i/web/status/${tweetId}`}></a>
            </blockquote>
        </div>
    );
};

export default TweetEmbed;
